/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { TrackItMeasurementParameterModalityDtoValue } from './TrackItMeasurementParameterModalityDtoValue';
import {
    TrackItMeasurementParameterModalityDtoValueFromJSON,
    TrackItMeasurementParameterModalityDtoValueFromJSONTyped,
    TrackItMeasurementParameterModalityDtoValueToJSON,
} from './TrackItMeasurementParameterModalityDtoValue';

/**
 * 
 * @export
 * @interface TrackItMeasurementParameterModalityDto
 */
export interface TrackItMeasurementParameterModalityDto {
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterModalityDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof TrackItMeasurementParameterModalityDto
     */
    trackItId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterModalityDto
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItMeasurementParameterModalityDto
     */
    index?: number;
    /**
     * 
     * @type {TrackItMeasurementParameterModalityDtoValue}
     * @memberof TrackItMeasurementParameterModalityDto
     */
    value?: TrackItMeasurementParameterModalityDtoValue | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterModalityDto
     */
    $type?: TrackItMeasurementParameterModalityDtoTypeEnum;
}


/**
 * @export
 */
export const TrackItMeasurementParameterModalityDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoTrackItMeasurementParameterModalityDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterModalityDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItMeasurementParameterModalityDtoTypeEnum = typeof TrackItMeasurementParameterModalityDtoTypeEnum[keyof typeof TrackItMeasurementParameterModalityDtoTypeEnum];



/**
 * Check if a given object implements the TrackItMeasurementParameterModalityDto interface.
 */
export function instanceOfTrackItMeasurementParameterModalityDto(value?: unknown): value is TrackItMeasurementParameterModalityDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItMeasurementParameterModalityDtoTypeEnum)[0];
}

export function TrackItMeasurementParameterModalityDtoFromJSON(json: any): TrackItMeasurementParameterModalityDto {
    return TrackItMeasurementParameterModalityDtoFromJSONTyped(json, false);
}

export function TrackItMeasurementParameterModalityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItMeasurementParameterModalityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'trackItId': json['trackItId'] == null ? undefined : json['trackItId'],
        'name': json['name'] == null ? undefined : json['name'],
        'index': json['index'] == null ? undefined : json['index'],
        'value': json['value'] == null ? undefined : TrackItMeasurementParameterModalityDtoValueFromJSON(json['value']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItMeasurementParameterModalityDtoToJSON(value?: TrackItMeasurementParameterModalityDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'trackItId': value['trackItId'],
        'name': value['name'],
        'index': value['index'],
        'value': TrackItMeasurementParameterModalityDtoValueToJSON(value['value']),
        '$type': value['$type'],
    });
}

